export const defaultPageSize = 12;
export const defaultPage = 1;
